export enum MatchStatus {
    CREATED = 'CREATED',
    OPENED = 'OPENED',
    HELD = 'HELD',
    FINISHED = 'FINISHED',
    REVEAL = 'REVEAL',
    CANCELED = 'CANCELED',
}
